import { AppDispatch } from '../../../../app/store';
import { TpDataContext } from '../../../../data/interfaces';
import { FORM_DATATYPES, TpAutoFormDef, promptAutoForm } from '../../../../components/auto-form-modal/AutoForm';
import { addNewStaticText, updateStaticTextSettings } from '../../data/dashboardsSlice';
import { get_guid } from '../../helpers/misc';
import { TpDashboardContext, TpStaticTextDefinition } from '../interfaces';

export function promptStaticTextSettings(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  elemDef: TpStaticTextDefinition,
  dispatch: AppDispatch,
) {
  const form: TpAutoFormDef = {
    title: 'Static text settings',
    fields: [
      {
        id: 'content',
        name: 'Content',
        dataType: FORM_DATATYPES.STRING,
        required: true,
        lineCount: 7,
        startContent: elemDef.content,
      },
    ],
  };

  promptAutoForm(form).then(
    (dataForm: any) => {
      dispatch(
        updateStaticTextSettings({
          dashboardDefId: dashboardContext.dashboardDefId,
          id: elemDef.id,
          content: dataForm.content,
        }),
      );
    },
    () => {},
  );
}

export function promptAddStaticText(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  parentId: string,
  dispatch: AppDispatch,
) {
  const form: TpAutoFormDef = {
    title: 'Create static text',
    fields: [
      {
        id: 'content',
        name: 'Content',
        dataType: FORM_DATATYPES.STRING,
        required: true,
        startContent: '',
        lineCount: 7,
      },
    ],
  };

  promptAutoForm(form).then(
    (dataForm: any) => {
      dispatch(
        addNewStaticText({
          dashboardDefId: dashboardContext.dashboardDefId,
          parentId,
          id: get_guid(),
          content: dataForm.content,
        }),
      );
    },
    () => {},
  );
}
